import { useState } from 'react';

import { Color } from '@/constants/color';
import Button from '@/ui/components/Button';
import DatetimePicker from '@/ui/components/Form/DatetimePicker';
import Spinner from '@/ui/components/Spinner';

import { Props } from './types';

const TaskSnoozedUntil = ({ itemId, snoozedUntil: initialSnoozedUntil, updateItem }: Props) => {
  const [snoozedUntil, setSnoozedUntil] = useState<string | null>(initialSnoozedUntil);

  const handleChange = (date: Date | null) => {
    setSnoozedUntil(date?.toISOString() ?? null);
  };

  const { isPending, mutate } = updateItem;

  const saveSnoozedUntil = () => {
    mutate({
      id: itemId,
      values: {
        snoozed_until: snoozedUntil
      }
    });
  };

  return (
    <div>
      <div className="mb-2 w-48">
        <DatetimePicker
          label="Snoozed Until"
          name="datetime-modify-snoozed-until"
          onChange={handleChange}
          placement="top-start"
          value={snoozedUntil}
        />
      </div>

      <Button color={Color.GREEN} disabled={isPending} onClick={saveSnoozedUntil}>
        {isPending ? <Spinner /> : 'Save Snoozed Until'}
      </Button>
    </div>
  );
};

export default TaskSnoozedUntil;
